import jsPDF from "jspdf";
import "jspdf-autotable";
import { LeaveRequestEnumLabel } from "Constants/Enums/LeaveRequestEnum";

function EmployeeOnLeaveFile(selectedDepartment, rows) {
  const handleDownloadReport = () => {
    if (!rows || rows.length === 0) {
      alert("No data available for download.");
      return;
    }

    //  Filter data by department
    const filteredData = rows.filter(
      (row) => selectedDepartment === "All Departments" || row.departmentName === selectedDepartment
    );

    if (filteredData.length === 0) {
      alert("No matching records found for the selected department.");
      return;
    }
    //  Prepare table data
    const data = filteredData.map((row) => {
      const employeeName =
        `${row.user?.firstName || ""} ${row.user?.lastName || ""}`.trim() || "N/A";
      const department = row.departmentName || "N/A";
      const daysOff = row.totalDays ?? "N/A";
      const fromDate = row.fromDate ? new Date(row.fromDate).toLocaleDateString() : "N/A";
      const toDate = row.toDate ? new Date(row.toDate).toLocaleDateString() : "N/A";
      const leavePolicy = row.leavePolicy?.policyName || "N/A";
      const status = LeaveRequestEnumLabel[row.status] || "N/A";

      return [employeeName, department, daysOff, fromDate, toDate, leavePolicy, status];
    });

    try {
      //  Initialize PDF
      const doc = new jsPDF();

      // Title
      doc.setFontSize(18);
      doc.text("Employee Leave Report", 14, 20);
      doc.setLineWidth(0.5);
      doc.setDrawColor(192, 192, 192);
      doc.line(14, 24, 200, 24);

      // Header info
      doc.setFontSize(11);
      doc.text(`Department: ${selectedDepartment}`, 14, 32);
      doc.text(`Generated On: ${new Date().toLocaleString()}`, 14, 38);

      //  Table
      doc.autoTable({
        startY: 45,
        head: [["Employee Name", "Department", "Days Off", "From", "To", "Leave Policy", "Status"]],
        body: data,
        headStyles: { fillColor: [220, 220, 220], textColor: 20, fontSize: 9 },
        styles: { fontSize: 9 },
      });

      const fileName = `employee_leave_report_${selectedDepartment.replace(/\s+/g, "_")}.pdf`;

      //  Edge-safe way: open in new tab
      const pdfBlob = doc.output("blob");
      const blobUrl = URL.createObjectURL(pdfBlob);

      // Works 100% in Edge (shows PDF in new tab)
      window.open(blobUrl);

      // Optional: if you want auto download instead, comment the line above and use below
      /*
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      */

      setTimeout(() => URL.revokeObjectURL(blobUrl), 2000);
    } catch (err) {
      console.error("❌ PDF Generation Error:", err);
      alert("Failed to generate PDF report. Check console for details.");
    }
  };

  return { handleDownloadReport };
}

export default EmployeeOnLeaveFile;
